import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Modal,
    notification,
    Space,
    Typography,
} from 'antd';
import API_SERVICE from '../../../services/api-service';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const { Text } = Typography;


export default function ChallengeQuestionCreateOrEditPage({ onClose, details, claimId, projectId, challengeId }: any) {
    const [question, setQuestion] = useState('');
    const [answer, setAnswer] = useState('');



    useEffect(() => {
        details && details.question && setQuestion(details.question);
        details && details.answer && setAnswer(details.answer);
    }, [details]);



    return (
        <Modal title={
            (<Space>
                <Text>{details ? 'Edit Technological & Scientific Uncertainty & Advancement details' : 'Fill in Technological & Scientific Uncertainty & Advancement details'}</Text>
            </Space>)
        }
               width={'70%'}
               visible={true}
               maskClosable={false}
               cancelText="Cancel"
               okText={details ? "Update" : "Save"}
               okType="primary"
               okButtonProps={{ shape: 'round' }}
               cancelButtonProps={{ shape: 'round', className: 'btn-dark' }}
               onOk={(value) => {
                   const reqObj = {
                       question,
                       answer
                   };

                   if (details) {
                       // console.log(reqObj); return;
                       API_SERVICE.updateChallengeQuestion(claimId, projectId, challengeId, details.id, reqObj).then((d) => {
                           notification.success({ message: 'Question updated successfully'});
                           onClose(true);
                       }).catch((e) => {
                           notification.error({ message: API_SERVICE.handleErrors(e) });
                       });
                   } else {
                       // console.log(reqObj); return;
                       API_SERVICE.createChallengeQuestion(claimId, projectId, challengeId, reqObj).then((d) => {
                           notification.success({ message: 'Question created successfully'});
                           onClose(true);
                       }).catch((e) => {
                           notification.error({ message: API_SERVICE.handleErrors(e) });
                       });
                   }
               }}
               onCancel={() => onClose()}>

            <div>
                <div className="question-title">Question 1:</div>
                <ReactQuill theme="snow" value={question} onChange={setQuestion} />
                <div className="question-title">Answer 1:</div>
                <ReactQuill theme="snow" value={answer} onChange={setAnswer} />
            </div>

        </Modal>
    );
}
